//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import _ from "js/underscore-mixins";

(function() {
  const curalate = angular.module('curalate');

  const ACTION_TYPES = {
    CLEAR: 'CLEAR',
    REMOVE_NEW_UPLOAD: 'REMOVE-NEW-UPLOAD',
    NEW_ITEMS: 'NEW-ITEMS',
    NEW_UPLOAD: 'NEW-UPLOAD',
    VIDEO_UPLOAD_COMPLETE: 'VIDEO-UPLOAD-COMPLETE',
    REMOVE: 'REMOVE',
    NEW_ITEM_COUNT: 'NEW-ITEM-COUNT',
    NEW_ITEM_STATS: 'NEW-ITEM-STATS',
    END_OF_ITEMS_REACHED_UPDATE: 'END-OF-ITEMS-REACHED-UPDATE',
  };
  const ITEM_LIMIT = 60;
  const ITEM_INCREMENT = 40;

  curalate.service('ContentLibraryItemsService', [
    '$log',
    'ContentLibraryHelper',
    'ContentLibraryService',
    'rx',
    function($log,
                 ContentLibraryHelper,
                 ContentLibraryService,
                 rx) {
      const self = this;
      let isRefreshing = false;

      const initialItemsState = {
        endOfItemsReached: false,
        itemCount: 0,
        items: [],
        itemStats: {},
        newUploads: [],
      };

      const itemsActions = new rx.Subject();

      const itemState = new rx.ReplaySubject(1);
      self.getItemState = function() {
        return itemState.asObservable();
      };

      const queuedUploads = new rx.Subject();
      self.getQueuedUploads = function() {
        return queuedUploads;
      };
      ContentLibraryService.queuedUploadsStream.subscribe(queuedUploads);

      const asyncStatus = new rx.Subject();
      self.getAsyncStatus = function() {
        return asyncStatus;
      };
      ContentLibraryService.asyncStatusStream.subscribe(asyncStatus);

      self.configure = function(preloadThumbnailUrl, pagesToLoad) {
        ContentLibraryService.setItemLimit(ITEM_LIMIT);
        ContentLibraryService.setItemIncrement(ITEM_INCREMENT);
        ContentLibraryService.setPreloadThumbnailUrl(preloadThumbnailUrl);

        if (pagesToLoad) {
          ContentLibraryService.setPagesToLoad(pagesToLoad);
        }
      };

      self.clearItemState = function() {
        itemsActions.next({
          type: ACTION_TYPES.CLEAR,
        });
      };

      self.getParams = function(filters) {
        return ContentLibraryService.getParams(filters);
      };

      self.refreshContent = function(filters) {
        itemsActions.next({
          type: ACTION_TYPES.CLEAR,
        });
        ContentLibraryService.setFilterParams(filters);
        ContentLibraryService.initialize();
      };

      self.refreshContentWithoutClear = function(filters) {
        isRefreshing = true;
        ContentLibraryService.setFilterParams(filters);
        ContentLibraryService.initialize();
      };

      self.fetchAdditionalContent = function(currentTotalItems) {
        ContentLibraryService.fetchAdditionalContent(currentTotalItems);
      };

      self.clearNewUpload = function(item) {
        itemsActions.next({
          type: ACTION_TYPES.REMOVE_NEW_UPLOAD,
          item,
        });
      };

      const removeItem = function(currentItems, itemId) {
        return _(currentItems).reject((item) => {
          return item.id === itemId;
        });
      };

      ContentLibraryService.endOfItemsReachedStream.map((endOfItemsReachedUpdate) => {
        return {
          type: ACTION_TYPES.END_OF_ITEMS_REACHED_UPDATE,
          endOfItemsReachedUpdate,
        };
      }).subscribe(itemsActions);

      ContentLibraryService.itemStream.map((newItems) => {
        return {
          type: ACTION_TYPES.NEW_ITEMS,
          items: newItems,
        };
      }).subscribe(itemsActions);

      ContentLibraryService.newContentUploadedStream.map((item) => {
        return {
          type: ACTION_TYPES.NEW_UPLOAD,
          item,
        };
      }).subscribe(itemsActions);

      ContentLibraryService.videoCompleteStream.map((item) => {
        return {
          type: ACTION_TYPES.VIDEO_UPLOAD_COMPLETE,
          item,
        };
      }).subscribe(itemsActions);

      ContentLibraryService.removeItemStream.map((itemIdToRemove) => {
        return {
          type: ACTION_TYPES.REMOVE,
          itemId: itemIdToRemove,
        };
      }).subscribe(itemsActions);

      ContentLibraryService.itemCountObservable.map((newItemCount) => {
        return {
          type: ACTION_TYPES.NEW_ITEM_COUNT,
          itemCount: newItemCount,
        };
      }).subscribe(itemsActions);

      ContentLibraryService.itemStatsObservable.map((newItemStats) => {
        return {
          type: ACTION_TYPES.NEW_ITEM_STATS,
          itemStats: newItemStats,
        };
      }).subscribe(itemsActions);

      itemsActions.scan((state, action) => {
        const newState = state;
        switch (action.type) {
          case ACTION_TYPES.NEW_ITEMS:
            if (isRefreshing) {
              newState.itemCount = 0;
              newState.itemStats = {};
              newState.items = [];
              isRefreshing = false;
            }
            newState.items = ContentLibraryHelper.contentItemConcat(newState.items, action.items);
            break;
          case ACTION_TYPES.NEW_UPLOAD:
            action.item.prepend = true;
            newState.items.unshift(action.item);
            newState.newUploads.push(action.item);
            newState.itemCount += 1;
            break;
          case ACTION_TYPES.VIDEO_UPLOAD_COMPLETE:
            action.item.prepend = true;
            newState.items = removeItem(newState.items, action.item.id);
            newState.items.unshift(action.item);
            break;
          case ACTION_TYPES.REMOVE:
            newState.items = removeItem(newState.items, action.itemId);
            newState.itemCount -= 1;
            break;
          case ACTION_TYPES.CLEAR:
            newState.items = [];
            newState.itemCount = 0;
            newState.itemStats = {};
            break;
          case ACTION_TYPES.REMOVE_NEW_UPLOAD:
            newState.newUploads = _(newState.newUploads).reject((newUploadItem) => {
              return newUploadItem.id === action.item.id;
            });
            break;
          case ACTION_TYPES.NEW_ITEM_COUNT:
            newState.itemCount = action.itemCount;
            break;
          case ACTION_TYPES.NEW_ITEM_STATS:
            newState.itemStats = action.itemStats;
            break;
          case ACTION_TYPES.END_OF_ITEMS_REACHED_UPDATE:
            newState.endOfItemsReached = action.endOfItemsReachedUpdate;
            break;
          default:
            $log.error(`unrecognized type: ${action.type}`);
            break;
        }
        return newState;
      }, initialItemsState).subscribe(itemState);
    },
  ]);
})();
